export const POST_USER_LOGIN = 'POST_USER_LOGIN';
export const POST_USER_LOGIN_SUCCESS = 'POST_USER_LOGIN_SUCCESS';
export const POST_USER_LOGIN_FAILED = 'POST_USER_LOGIN_FAILED';
export const DELETE_AUTH = 'DELETE_AUTH';
export const SET_MODAL = 'SET_MODAL';
export const OFF_MODAL = 'OFF_MODAL';
